// @dynamic-i18n-keys
//   boostDeviation.modal.title.noCore
//   boostDeviation.modal.title.noCore.tier
import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { CancelButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import BuyCoreBrandedButton from '../../../../../Button/core/dsPresets/BuyCoreBrandedButton';
import { MODAL_FOOTER_BUTTON_SIZE } from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import BoostIllustration from '../BoostIllustration';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';

interface Props {
  isTier?: boolean;
  onRequestClose: () => void;
}

const BoostNoCoreModal: React.FC<Props> = ({ isTier, onRequestClose }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);

  return (
    <MessageModal
      isOpen
      onRequestClose={onRequestClose}
      image={<BoostIllustration />}
      variant={isMobile ? 'vertical' : 'horizontal'}
      title={t(`boostDeviation.modal.title.noCore${isTier ? '.tier' : ''}`)}
      message={
        <Trans
          i18nKey={`boostDeviation.modal.message.noCore${
            isTier ? '.tier' : ''
          }`}
        >
          Core Members get free monthly boosts to make their deviation more
          visible in browse. Additional boosts can be purchased with points.{' '}
          <a
            target="_blank"
            className="link"
            href={t('boostDeviation.learnMoreUrl')}
            rel="noreferrer"
          >
            Learn more
          </a>
        </Trans>
      }
      footerButtons={[
        <CancelButton key="cancel" onClick={onRequestClose}>
          {t('popup.cancel')}
        </CancelButton>,
        <BuyCoreBrandedButton
          key="buy-core"
          biData={BiData<BuyCoreButtonBiEvent>({
            evid: 375,
            referral_info: ReferralType.BOOST_UPGRADE_CORE_POPUP,
          })}
          size={MODAL_FOOTER_BUTTON_SIZE}
        >
          {t('common.getCore')}
        </BuyCoreBrandedButton>,
      ]}
    />
  );
};
BoostNoCoreModal.displayName = 'BoostNoCoreModal';

export default BoostNoCoreModal;
